module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_0@3x.994579bb.png";